/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExtendRestrictionRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/extend_restriction.pb'
import {ExtendRestrictionResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/extend_restriction.pb'


export const extendRestriction = (request: ExtendRestrictionRequest, options?: CashRequestOptions) => post<ExtendRestrictionRequest, ExtendRestrictionResponse>("/2.0/cash/extend-restriction", request, {...options, rejectOnError: true })